
export const GLOBAL_NAMESPACE = 'shn.monix.';
export const AUTHORIZATION = GLOBAL_NAMESPACE + 'authorization';
export const REMEMBER_USERNAME = GLOBAL_NAMESPACE + 'username';
export const REMEMBER_PASSWORD = GLOBAL_NAMESPACE + 'password';
export const REMEMBER_TAG = GLOBAL_NAMESPACE + 'remember';
export const PROJECT_UUID = GLOBAL_NAMESPACE + 'project_uuid';
export const PROJECT_NAME = GLOBAL_NAMESPACE + 'project_name';
export const USER_UUID = GLOBAL_NAMESPACE + 'user_uuid';
export const USER_NAME = GLOBAL_NAMESPACE + 'user_name';
export const USER_META = GLOBAL_NAMESPACE + 'user_meta';
export const USER_MOBILE = GLOBAL_NAMESPACE + 'user_mobile';
export const AVATAR = GLOBAL_NAMESPACE + 'avatar';
export const AUTHORITY = GLOBAL_NAMESPACE + 'authority';

class LocalStore {

    public get(key: string) {
        return JSON.parse(localStorage.getItem(key) || 'null') || null;
    }

    public set(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    public remove(key: string): void {
        localStorage.removeItem(key);
    }

    get token(): string {
        return this.get(AUTHORIZATION) || '';
    }

    set token(value: string) {
        this.set(AUTHORIZATION, value);
    }

    get userUuid(): string {
        return this.get(USER_UUID) || '';
    }
    set userUuid(value: string) {
        this.set(USER_UUID, value);
    }

    get name(): string {
        return this.get(USER_NAME) || '';
    }
    set name(value: string) {
        this.set(USER_NAME, value);
    }

    get mobile(): string {
        return this.get(USER_MOBILE) || '';
    }
    set mobile(value: string) {
        this.set(USER_MOBILE, value);
    }

    get password(): string {
        return this.get(REMEMBER_PASSWORD) || '';
    }
    set password(value: string) {
        this.set(REMEMBER_PASSWORD, value);
    }

    get projectUuid(): string {
        return this.get(PROJECT_UUID) || '';
    }
    set projectUuid(value: string) {
        this.set(PROJECT_UUID, value);
    }

    get projectName(): string {
        return this.get(PROJECT_NAME) || '';
    }
    set projectName(value: string) {
        this.set(PROJECT_NAME, value);
    }

    public setAuthority(types: number[]) {
        if (types == null) {
            this.remove(AUTHORITY);
            return;
        }
        this.set(AUTHORITY, types);
    }

    public getAuthority() {
        return this.get(AUTHORITY);
    }


    clear() {
        this.remove(AUTHORIZATION);
        this.remove(PROJECT_UUID);
        this.remove(PROJECT_NAME);
    }
}

export default new LocalStore();